import { render, staticRenderFns } from "./deleteFundPayment.vue?vue&type=template&id=0678f08e&scoped=true"
import script from "./deleteFundPayment.vue?vue&type=script&lang=js"
export * from "./deleteFundPayment.vue?vue&type=script&lang=js"
import style0 from "./deleteFundPayment.vue?vue&type=style&index=0&id=0678f08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678f08e",
  null
  
)

export default component.exports